let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("j8CYW")).then(() => parcelRequire('jFMLI'));